import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, ButtonBase } from '@mui/material';
import LogoSection from '../LogoSection';
import ProfileSection from './ProfileSection';
import NotificationSection from './NotificationSection';
import ThemeModeToggle from '../../../ui-component/ThemeModeToggle';
import { IconMenu2 } from '@tabler/icons';

const Header = ({ handleLeftDrawerToggle, userData, showBrand = true, showMenuButton = false, showUserControls = true }) => {
  const theme = useTheme();

  return (
    <>
      {showBrand && (
        <Box
          sx={{
            width: 228,
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            [theme.breakpoints.down('md')]: {
              width: 'auto'
            }
          }}
        >
          <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
            <LogoSection />
          </Box>
          {showMenuButton && (
            <ButtonBase
              aria-label="Meniu"
              onClick={handleLeftDrawerToggle}
              sx={{ borderRadius: '10px', overflow: 'hidden' }}
            >
              <Avatar
                variant="rounded"
                sx={{
                  ...theme.typography.commonAvatar,
                  ...theme.typography.mediumAvatar,
                  transition: 'background-color .15s ease, color .15s ease',
                  background: theme.palette.secondary.light,
                  color: theme.palette.secondary.dark,
                  '&:hover': {
                    background: theme.palette.secondary.dark,
                    color: theme.palette.secondary.light
                  }
                }}
              >
                <IconMenu2 stroke={1.5} size="1.3rem" />
              </Avatar>
            </ButtonBase>
          )}
        </Box>
      )}

      <Box sx={{ flexGrow: 1 }} />

      {showUserControls && <ThemeModeToggle />}
      <NotificationSection variant="header" userData={userData} />
      {showUserControls && <ProfileSection userData={userData} />}
    </>
  );
};

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func,
  userData: PropTypes.object,
  showBrand: PropTypes.bool,
  showMenuButton: PropTypes.bool,
  showUserControls: PropTypes.bool
};

export default Header;